<!-- <div *ngIf="!pageShow.showLevel1BomItemsData && !pageShow.showerrorFreeBomItemsData && isPriceMatrixHidden" class="mb-5 mt-5 pb-5 pt-5"></div> -->
<div class="vh_center mt-4">
  <div col="12">
    <div style=" margin:0px; " class="vh_center">
      <img class=" " src="assets/img/c_va.png" width="27" height="27" style=" float:left;" />
      <div style="width:130px; height:5px; background-color: #fcb816;"></div>
      <img class=" " src="assets/img/c_yl.png" width="27" height="27" style=" float:left;" />
      <div style="width:130px; height:5px; background-color: #dadada;"></div>
      <img class=" " src="assets/img/c_ge.png" width="27" height="27" style=" float:left;" />
      <div style="width:130px; height:5px; background-color: #dadada;"></div>
      <img class=" " src="assets/img/c_ge.png" width="27" height="27" style=" float:left;" />
      <div style="width:130px; height:5px; background-color: #dadada;"></div>
      <img class=" " src="assets/img/c_ge.png" width="27" height="27" style=" float:left;" />
    </div>
  </div>
</div>
<div class="vh_center mt-2">
  <div col="12">
    <div style=" margin:0px; font-size: 14px; color:#999999; " class="vh_center">
      <div style="width:210px; padding-left: 45px;  background-color: #ffffff;">File Validation</div>
      <div style="width:150px;  padding-left: 15px; background-color: #ffffff;">Quote</div>
      <div style="width:150px; padding-left: 0px;  background-color: #ffffff;">Order Details</div>
      <div style="width:150px; padding-left: 0px;  background-color: #ffffff;">Review & Confirm</div>
      <div style="width:150px;   padding-left: 15px;  background-color: #ffffff;">Place Order</div>
    </div>
  </div>
</div>

<section class="" style="padding-left: 5%;padding-right: 5%;">

  <h2 class="text-center header-title page_top_space"> <b>Assembly Labor Pricing</b> </h2>

  <div class="row mt-5 mb-5">
    <div class="col-8">
      <div class="page-heading plr-15" >@if (!assemblyDefaultCheck) {
        <span>Choose </span>
      }Available Turn Time & Quantity: Assembly</div>
      <div class="mb-3 plr-15 yellow-txt f-14">PER UNIT PRICES FOR ASSEMBLY LABOR</div>
      <div class="plr-15 mb-3">
        <table class="table table-bordered"  id="assembly-matrix-table" style="text-align: center;">
          <thead>
            <tr>
              <th class="tt-width">Assembly Turn time<hr style="margin: 5px;">Quantity</th>
              @for (mat of commonService.commonMainObj.assemblyMatrixColData; track mat; let i = $index) {
                <th class="pad-b25 text-center" style="vertical-align: middle;"  >{{commonService.commonMainObj.assemblyMatrixColData[i].field}}</th>
              }
            </tr>
          </thead>
          <tbody >
            @for (element of commonService.commonMainObj.assemblyMatrixRowData; track element; let i = $index) {
              <tr>
                <td class="mat-qty" style="font-weight: bold;">{{commonService.commonMainObj.assemblyMatrixRowData[i].turnTimeQuantity}}</td>
                @for (col of commonService.commonMainObj.assemblyMatrixColData; track col; let j = $index) {
                  <td class="mat-d text-center">
                    <input  type="radio" class="mr-5" name="panel-main-get-quote-assembly-matrix-turnTimeQuantity" id='panel-main-get-quote-assembly-matrix-turnTimeQuantity' value="{{col.field}}" [attr.data-quantity]="commonService.commonMainObj.assemblyMatrixRowData[i].turnTimeQuantity"(click)="checkAssemblyPrice(col.field,commonService.commonMainObj.assemblyMatrixRowData[i].turnTimeQuantity,commonService.commonMainObj.assemblyMatrixRowData[i][col.field])" [checked]="assemblyDefaultCheck == true? true:false">
                    <label class="mat-lable" for="panel-main-get-quote-assembly-matrix-turnTimeQuantity0"  > &nbsp;${{commonService.commonMainObj.assemblyMatrixRowData[i][col.field]}}</label>
                  </td>
                }
              </tr>
            }
          </tbody>
        </table>
      </div>
      <div class="plr-15 fs-14 mb-3"  [hidden]="viaInPadCheckHidden">
        <p class="fw-b" style="color: red;"><i>Please note with via-in-pad features, total turn time will be minimum 7 days</i></p>
      </div>
      <div class="plr-15 fs-14" >
        <p>Labor charges shown do not include special services such as wire-bonding and conformal coating. These charges also exclude assembly of components that require special fixtures, such as PEM nuts, Turret Terminals and Press-Fit connectors. If any such special services are required they will be quoted separately after your online order is placed.</p>
      </div>
    </div>
    <div class="col-4">
      <div class="fab-info-sec">
        <h3 class="mb-4 text-center" style="font-size: 1.2rem;">CURRENT SELECTIONS</h3>
        <p class="fw-b" style="color: brown;">PCB Fabrication</p>
        <div class="row mb-3">
          <div class="col-6 text-center">PART/REV <span class="align-colon">:</span></div>
          <div class="col-6 " style="word-wrap: break-word;">{{commonService.commonMainObj.partNumber}} / {{commonService.commonMainObj.partRevision}}</div>
        </div>
        <div class="row mb-3">
          <div class="col-6 text-center">TURNTIME <span class="align-colon">:</span></div>
          <div class="col-6 ">{{commonService.commonMainObj.selectedFabTurntime}} </div>
        </div>
        <div class="row mb-3">
          <div class="col-6 text-center">QUANTITY <span class="align-colon">:</span></div>
          <div class="col-6 ">{{commonService.commonMainObj.selectedFabQuantity}} boards</div>
        </div>
        <div class="row mb-3">
          <div class="col-6 text-center">LOT PRICE <span class="align-colon">:</span></div>
          <div class="col-6 ">${{commonService.commonMainObj.selectedFabLotPrice | number : '1.2-2'}}</div>
        </div>
        <p class="fw-b mt-4" style="color: brown;">Components</p>
        <div class="row mb-3">
          <div class="col-6 text-center">{{commonService.commonMainObj.finalBomDataToPurchase?.okayToBuy?.componentTotalModel?.componentTotalText.split('Component Total')[1].split(':')[0]}} <span class="align-colon">:</span></div>
          <div class="col-6 ">${{commonService.commonMainObj.CppComponentTotalPrice}}</div>
          @if (commonService.commonMainObj.finalBomDataToPurchase?.okayToBuy?.componentTotalModel?.minChargeText) {
            <div class="m-0 fs12 text-end text-danger"> {{commonService.commonMainObj.finalBomDataToPurchase?.okayToBuy?.componentTotalModel?.minChargeText}} </div>
          }
        </div>
        @if (commonService.commonMainObj.finalBomDataToPurchase?.issueFound != null && commonService.commonMainObj.finalBomDataToPurchase?.issueFound?.items.length>0) {
          <div class="" style="color:red">NOTE: This is a budgetary price and only covers the components that do not have issues</div>
        }
        @if (!commonService.commonMainObj.onlyPcb) {
          <div class="">
            <p class="fw-b mt-4" style="color: brown;">Assembly Labor</p>
            <div class="row mb-3">
              <div class="col-6 text-center">PART/REV <span class="align-colon">:</span></div>
              <div class="col-6 " style="word-wrap: break-word;">{{commonService.commonMainObj.partNumber}} / {{commonService.commonMainObj.partRevision}}</div>
            </div>
            <div class="row mb-3">
              <div class="col-6 text-center">TURNTIME <span class="align-colon">:</span></div>
              <div class="col-6 ">{{commonService.commonMainObj.selectedAssemblyTurntime}} </div>
            </div>
            <div class="row mb-3">
              <div class="col-6 text-center">QUANTITY <span class="align-colon">:</span></div>
              <div class="col-6 ">{{commonService.commonMainObj.selectedAssemblyQuantity}} assemblies</div>
            </div>
            <div class="row mb-3">
              <div class="col-6 text-center">LOT PRICE <span class="align-colon">:</span></div>
              <div class="col-6 ">${{commonService.commonMainObj.selectedAssemblyLotPrice | number : '1.2-2'}}</div>
            </div>
          </div>
        }
        <hr>
          <div class="row mb-4 fw-b" style="color: brown;">
            <div class="col-6 text-center">TOTAL</div>
            <!-- <div class="col-5 text-right">{{commonService.commonMainObj.selectedFabPrice * commonService.commonMainObj.selectedFabQuantity | number : '1.2-2'}}</div> -->
            <div class="col-6">${{pcbComponetTotal | number:'1.2-2'}}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="text-center mb-5">
      <button type="button" class="btn btn-custom btn-warning px-xxl-5 m-3 btn-danger btn-red-custom" data-mdb-toggle="button" autocomplete="off" aria-pressed="true" (click)="commonService.goBack()"> <b>Cancel</b>
    </button>
    <button id="assembly-quote-proceed-btn" type="button" class="btn btn-custom btn-warning btn_blue_custom px-xxl-5 m-3" (click)="navigateToQuoteDetails()"><b>View Final Quote</b></button>
    <!-- removed disabled OFP-613 -->
  </div>
</section>

<app-footer></app-footer>